import styled from 'styled-components';
import { THEME } from '@/common/styles/theme';

const ProgressBarWrapper = styled.div`
	width: 100%;
	height: 6px;
	margin: 8px 0 12px;
	border-radius: 999px;
	background: ${THEME.panelSoft};
	overflow: hidden;
	border: 1px solid rgba(255, 255, 255, 0.05);
`;

const ProgressFill = styled.div`
	height: 100%;
	width: ${({ $width }) => $width}%;
	background: linear-gradient(
		90deg,
		${THEME.gold} 0%,
		${THEME.peach} 50%,
		${THEME.gold} 100%
	);
	box-shadow: 0 0 10px rgba(255, 211, 107, 0.4);
	border-radius: 12px;
	transition: width 0.6s cubic-bezier(0.4, 0, 0.2, 1);
`;

const calcPercents = (current, max) => Math.min((current / max) * 100, 100);

const StudioProgressBar = ({ currentIndex, maxSteps }) => {
	const progress =
		currentIndex <= 1 ? 5 : calcPercents(currentIndex, maxSteps);

	return (
		<ProgressBarWrapper>
			<ProgressFill $width={progress} />
		</ProgressBarWrapper>
	);
};

export default StudioProgressBar;
